
import React from "react";

export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-12 lg:p-16 text-center shadow-2xl">
            <div className="inline-block px-6 py-2 bg-blue-100 text-blue-600 rounded-full text-sm font-semibold mb-8">
              10 Lat na Rynku
            </div>

            <p className="text-2xl lg:text-3xl text-gray-800 leading-relaxed mb-8 font-serif">
              TM GARANT tworzą specjaliści z różnych dziedzin, jednak każdy z nas ma ponadprzeciętne
              umiejętności oraz wieloletnie doświadczenie. Nasza misja to nie tylko osuszanie i remonty,
              ale przede wszystkim przywracanie spokoju i komfortu życia naszym klientom. Każdy projekt
              traktujemy indywidualnie, dbając o najwyższe standardy wykonania. 💙
            </p>

            <div className="border-t border-gray-200 pt-6">
              <p className="text-lg font-bold text-gray-900">TM GARANT</p>
              <p className="text-sm text-gray-500">Specjaliści od osuszania i remontów</p>
            </div>
          </div>

          {/* Partner Logos */}
          <div className="flex justify-center items-center gap-12 mt-12 opacity-60">
            <div className="text-white text-sm font-semibold">Certyfikowany Partner</div>
            <div className="w-20 h-20 flex items-center justify-center">
              <i className="ri-shield-check-line text-5xl text-white"></i>
            </div>
            <div className="w-20 h-20 flex items-center justify-center">
              <i className="ri-award-line text-5xl text-white"></i>
            </div>
            <div className="w-20 h-20 flex items-center justify-center">
              <i className="ri-medal-line text-5xl text-white"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
